module.exports = __webpack_public_path__ + "img/icon.b36aea95.png";